import { getNumberOfSavedResources } from '../../primary-nav-rse/js/global';

const parent = function (el, match, last) {
    const result = [];
    for (let p = el && el.parentElement; p; p = p.parentElement) {
        result.push(p);
        if (p.matches(match)) {
            break;
        }
    }
    if (last === 1) {
        return result[result.length - 1];
    }
    return result;
};

function removeThisResourceFromLocalStorage(e) {
    const resourceId = e.target.dataset.resourceid;
    const savedResources = JSON.parse(window.localStorage.savedResources);

    const remainingResources = savedResources.filter((item) => {
        return item.assetId !== resourceId;
    });

    window.localStorage.setItem(
        'savedResources',
        JSON.stringify(remainingResources)
    );

    /* 
    remove card animation
    https://dev.to/smpnjn/how-to-do-deletion-animations-with-css-3a51
    */
    const getParent = parent(this, '.saved-resource', 1);
    getParent.classList.add('zoom');

    getNumberOfSavedResources();
}

export default function _removeSavedResource() {
    const removeButtons = document.querySelectorAll('.remove');

    removeButtons.forEach((button) => {
        button.addEventListener('click', removeThisResourceFromLocalStorage);
    });
}

window.addEventListener('DOMContentLoaded', _removeSavedResource);
